import { render, staticRenderFns } from "./ProductCertificationIframe.vue?vue&type=template&id=4609073d&"
import script from "./ProductCertificationIframe.vue?vue&type=script&lang=ts&"
export * from "./ProductCertificationIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports